import { Fragment } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { useActiveFrameworkCard } from "./hooks/useActiveFrameworkCard";

type FrameworkCardDataProps = {
  data: ReturnType<typeof useActiveFrameworkCard>["data"];
};

export function ActiveFrameworkCardData({ data }: FrameworkCardDataProps) {
  const includedStats = ["controls", "assets", "exceptions"];
  // filter out any stats that are not included
  const displayedStats = data.frameworkStats?.filter((x) =>
    includedStats.includes(x.key),
  );

  return (
    <Fragment>
      <Grid
        container
        sx={{
          height: 80,
          px: 0,
          py: 2,
          alignItems: "center",
          justifyContent: "left",
        }}
        size={8}
      >
        {displayedStats?.map((stat) => (
          <Grid
            key={stat.key}
            sx={{
              textAlign: "center",
            }}
            size={3}
          >
            <Typography
              fontSize={11}
              fontWeight={600}
              lineHeight="16px"
              color="text.secondary"
              sx={{ pb: 1, textTransform: "uppercase" }}
            >
              {stat.key}
            </Typography>
            <Typography
              className={"integrations-value"}
              fontSize={24}
              lineHeight="15px"
              fontWeight={800}
            >
              {/* if looking at controls, we reach into */}
              {/* {typeof value === "object" && value.__typename === "ControlsStats"
                ? value.totalControls.toLocaleString()
                : value.toLocaleString()} */}
              {stat.value}
            </Typography>
          </Grid>
        ))}
      </Grid>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          py: 2,
          pr: 3,
        }}
        size="grow"
      >
        <Box>{data.displayInteractions}</Box>
      </Grid>
    </Fragment>
  );
}
